import * as constants from './actionTypes'
import { serialize } from '../utility/serialization'

import Axios from '../axios'

export function successTogglingCommunityFeature(response) {
  return {
    type: constants.TOGGLE_COMMUNITY_FEATURE,
    features: response.data.features,
  }
}

export function successTogglingUserCommunityFeature(response, communityId) {
  return {
    type: constants.TOGGLE_USER_COMMUNITY_FEATURE,
    features: response.data.features,
    communityId,
  }
}

// THUNKS HERE

export function toggleCommunityFeature(communityId, feature) {
  return function(dispatch) {
    return (feature.enabled
      ? requestDisableFeature(communityId, feature.key)
      : requestEnableFeature(communityId, feature.key)
    ).then((response) => dispatch(successTogglingCommunityFeature(response)))
  }
}

export function toggleUserCommunityFeature(communityId, feature) {
  return function(dispatch) {
    return (feature.enabled
      ? requestDisableFeature(communityId, feature.key)
      : requestEnableFeature(communityId, feature.key)
    ).then((response) => dispatch(successTogglingUserCommunityFeature(response, communityId)))
  }
}

// API CALLS

function requestEnableFeature(communityId, featureKey) {
  const requestUrl = '/api/v1/features/enable'
  const featureData = {
    communityId: communityId,
    featureKey: featureKey,
  }

  return Axios.post(requestUrl, serialize(featureData))
}

function requestDisableFeature(communityId, featureKey) {
  const requestUrl = '/api/v1/features/disable'
  const featureData = {
    communityId: communityId,
    featureKey: featureKey,
  }

  return Axios.post(requestUrl, serialize(featureData))
}
